<template>
  <div id="app">
    <div id="map">
    </div>
    <div id="web-container">
      <div class="header">
        <el-row :gutter="10">
          <el-col :xs="0" :sm="4" :md="4" :lg="4" :xl="4">
            <div class="labLog"></div>
          </el-col>
          <el-col :xs="9" :sm="12" :md="16" :lg="14" :xl="14">
            <div class="teamTitle">
              <span class="zh">实时遥感智能服务团队</span>
              <span class="en">Real-time Intelligent Remote Sensing Service</span>
              <span class="labName">武汉大学测绘遥感信息工程国家重点实验室</span>
            </div>
          </el-col>
          <el-col :xs="12" :sm="0" :md="0" :lg="0" :xl="0">
            <div class="labLog"></div>
          </el-col>
          <el-col :xs="0" :sm="8" :md="4" :lg="6" :xl="6">
            <div class="whuLog"></div>
          </el-col>
        </el-row>
      </div>
      <div class="navMenu">
        <el-menu :default-active="activeIndex" mode="horizontal" :router="true">
          <el-menu-item
              @click="saveNavState('/index')"
              index="/index"
          >首  页</el-menu-item
          >
          <el-menu-item
              @click="saveNavState('/team')"
              index="/team"
          >团队简介</el-menu-item
          >
          <el-menu-item
              @click="saveNavState('/academic')"
              index="/academic"
          >学术成果</el-menu-item
          >
          <el-menu-item
              @click="saveNavState('/scientific')"
              index="/scientific"
          >科研成果</el-menu-item
          >
          <!-- <el-menu-item
              @click="saveNavState('/projects')"
              index="/projects"
          >科研项目</el-menu-item
          > -->
          <el-menu-item
              @click="saveNavState('/comnt&student')"
              index="/comnt&student"
          >学术交流</el-menu-item
          >
          <el-menu-item
              @click="saveNavState('/conact')"
              index="/conact"
          >加入我们</el-menu-item
          >
        </el-menu>
      </div>
      <div class="container">
        <router-view/>
      </div>
      <div class="footer">
        <div class="copyState">
          武汉大学测绘遥感信息工程国家重点实验室眭海刚教授课题组 &copy; 2025
        </div>
        <div style="text-align: center;font-size: 14px">
          <el-link href="https://www.whu.edu.cn/" target="_blank">武汉大学</el-link>
          <el-link href="http://www.lmars.whu.edu.cn/" target="_blank">测绘遥感信息工程国家重点实验室</el-link>
        </div>
        <div class="contact">
          <span>地址：湖北省武汉市珞喻路129号</span>
          <span>邮编：430079</span>
          <span>QQ：1669378879</span>
          <span>邮箱：haigang_sui@263.net</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      activeIndex: "/index", //默认
    };
  },
  created() {
    this.activeIndex = window.sessionStorage.getItem("indexactivePath");
    if(this.activeIndex !== null){
      this.saveNavState(this.activeIndex)
    } else {
      this.saveNavState("/index")
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    saveNavState(activePath) {
      var activePathKeys = activePath.split("/")
      if (activePathKeys.length<3){
        window.sessionStorage.setItem("indexactivePath", activePath);
        this.activeIndex = activePath;
        console.log(this.activeIndex)
        this.$router.push(activePath)
      } else {
        var activeIndex = "/" + activePathKeys[1]
        window.sessionStorage.setItem("indexactivePath", activeIndex);
        this.activeIndex = activeIndex;
        this.$router.push({path:activePath, query: {path: activePath}})
      }
    },
    initMap(){
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 960px;
  background-image: linear-gradient(rgba(96,195,245, 0.3), rgba(96,195,245, 0.1),rgba(7, 100, 105, 0));
  #map{
    z-index: -1;
    min-height: 960px;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
  }
  #web-container {
    .header{
      width: 995px;
      margin: 0 auto;
      padding-top: 5px;
      height: 100px;
      .labLog{
        background: url("./assets/img/liesmars.png") no-repeat;
        width: 96px;
        height: 72px;
      }
      .teamTitle{
        padding-left: 10px;
        .zh{
          padding-top: 5px;
          display: block;
          font-size: 24px;
          font-weight: bolder;
          color: rgb(4,62,96);
        }
        .en{
          display: block;
          padding-top: 2px;
          padding-bottom: 10px;
        }
        .labName{
          color: #000E7A;
          display: block;
          height: 20px;
          line-height: 20px;
          font-weight: bold;
        }
      }
      .whuLog{
        background: url("./assets/img/whu.png") no-repeat;
        width: 245px;
        height: 78px;
      }
    }
    .navMenu{
      height: 60px;
      background-color: rgb(0, 104, 165);
      box-shadow: 0px 1px 2px #4f4f4f;
      .el-menu.el-menu--horizontal {
        border-bottom: none;
      }
      .el-menu{
        width: 995px;
        margin: 0 auto;
        background-color: rgb(0, 104, 165);
        .el-menu-item{
          color: white;
        }
        .el-menu-item:hover{
          color: #ffffff;
          background-color: #008ad7;
        }
        li.el-menu-item.is-active {
          background-color: #008ad7;
        }
      }

    }
    .container{
      min-height: 720px;
      width: 995px;
      margin: 0 auto;
      .main{
        background-color: rgba(255,255,255,0.6);
      }
    }
    .footer{
      height: 100px;
      background-color: rgba(102,202,251, 0.2);
      .copyState{
        text-align: center;
        font-size: 18px;
        padding: 10px 0;
      }
      .el-link {
        margin: 0 10px;
        font-size: 14px;
        color: #676767;
      }
      .contact{
        margin: 10px 0;
        font-size: 14px;
        text-align: center;
        span {
          padding-right: 20px;
          color: #3c3c3c;
        }
      }
    }
  }

}
</style>
